import React from 'react';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import { Box, Button, TextField, Avatar, Typography } from '@material-ui/core';
import { useFormik } from 'formik';

import validationSchema from 'forms/administrator/loanOfficerForm';
import LoanOfficerPresenter from 'presenters/administrator/LoanOfficerPresenter';

import useStyles from './useStyles';

const LoanOfficerForm = props => {
  const classes = useStyles();
  const { loanOfficer, onSubmit } = props;
  const { t } = useTranslation();

  const formik = useFormik({
    validationSchema,
    initialValues: loanOfficer,
    onSubmit,
  });

  const { errors, values, handleChange, handleBlur, touched, handleSubmit } = formik;

  const isAbleToSubmit = isEmpty(errors);

  return (
    <Box className={classes.container}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <div className={classes.fields}>
          <div className={classes.loanOfficerInfoBox}>
            <div className={classes.avatar}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.AdministratorLoanOfficer.LoanOfficerForm.profileImage')}
              </Typography>
              <Avatar
                alt={t('components.AdministratorLoanOfficer.LoanOfficerForm.avatar')}
                src={LoanOfficerPresenter.profileImageUrl(loanOfficer)}
                className={classes.image}
                variant="rounded"
              />
            </div>
            <TextField
              variant="outlined"
              id="loanOfficerName"
              name="loanOfficerName"
              type="text"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.loanOfficerName')}
              autoComplete="loanOfficerName"
              value={values.loanOfficerName}
              className={classes.field}
              disabled
              InputLabelProps={{
                shrink: false,
              }}
            />
            <TextField
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && t(errors.email)}
              variant="outlined"
              id="email"
              name="email"
              type="email"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.email')}
              autoComplete="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              className={classes.field}
              InputLabelProps={{
                shrink: false,
              }}
            />
            <TextField
              error={touched.nmls && Boolean(errors.nmls)}
              helperText={touched.nmls && t(errors.nmls)}
              variant="outlined"
              id="nmls"
              name="nmls"
              type="text"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.nmls')}
              autoComplete="nmls"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.nmls}
              className={classes.field}
              InputLabelProps={{
                shrink: false,
              }}
            />
          </div>
          <div className={classes.loanOfficerCompanyBox}>
            <div className={classes.companyLogo}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.AdministratorLoanOfficer.LoanOfficerForm.companyLogo')}
              </Typography>
              <Avatar
                alt={t('components.AdministratorLoanOfficer.LoanOfficerForm.companyLogo')}
                src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
                className={classes.companyLogoImage}
                variant="square"
              />
            </div>
            <TextField
              error={touched.savedMortgageCompanyNmls && Boolean(errors.savedMortgageCompanyNmls)}
              helperText={touched.savedMortgageCompanyNmls && t(errors.savedMortgageCompanyNmls)}
              variant="outlined"
              id="savedMortgageCompanyNmls"
              name="savedMortgageCompanyNmls"
              type="text"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.mortgageCompanyNmls')}
              autoComplete="mortgageCompanyNmls"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.savedMortgageCompanyNmls || ''}
              className={classes.field}
              InputLabelProps={{
                shrink: false,
              }}
            />
            <TextField
              error={touched.savedCompany && Boolean(errors.savedCompany)}
              helperText={touched.savedCompany && t(errors.savedCompany)}
              variant="outlined"
              id="savedCompany"
              name="savedCompany"
              type="text"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.company')}
              autoComplete="company"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.savedCompany || ''}
              className={classes.field}
              InputLabelProps={{
                shrink: false,
              }}
            />
            <TextField
              variant="outlined"
              id="bundleCompanyName"
              name="bundleCompanyName"
              type="text"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.bundleCompanyName')}
              autoComplete="bundleCompanyName"
              disabled
              value={values.bundleCompanyName || ''}
              className={classes.field}
              InputLabelProps={{
                shrink: false,
              }}
            />
            <TextField
              variant="outlined"
              id="companyEmailExtension"
              name="companyEmailExtension"
              type="text"
              label={t('components.AdministratorLoanOfficer.LoanOfficerForm.companyEmailExtension')}
              autoComplete="companyEmailExtension"
              disabled
              value={values.companyEmailExtension || ''}
              className={classes.field}
              InputLabelProps={{
                shrink: false,
              }}
            />
          </div>
        </div>
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {t('components.AdministratorLoanOfficer.LoanOfficerForm.button')}
        </Button>
      </form>
    </Box>
  );
};

LoanOfficerForm.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
};

export default LoanOfficerForm;



// WEBPACK FOOTER //
// ./src/components/AdminLoanOfficer/components/LoanOfficerForm/LoanOfficerForm.js